import { render } from "./CardDisplay.vue?vue&type=template&id=42b12fac&scoped=true"
import script from "./CardDisplay.vue?vue&type=script&lang=js"
export * from "./CardDisplay.vue?vue&type=script&lang=js"

import "./CardDisplay.vue?vue&type=style&index=0&id=42b12fac&scoped=true&lang=css"

import exportComponent from "/Volumes/development/experiments/kartograph/cartographer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b12fac"]])

export default __exports__